import React, { useEffect, useState } from 'react';
import { Table, Rate, Tag, Space, Drawer, List, Avatar, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getFeedBack } from '../../redux/FeedBack/feedBackActions';
import { UserOutlined } from '@ant-design/icons';

const FeedBack = () => {
    const userData = useSelector((state) => state.Auth.userData);
    const [isShow, setisShow] = useState(false);
    const [Selected, setSelected] = useState([]);

    const { isLoadingFeedBack, feedBackData } = useSelector((state) => state.FeedBackReducer);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getFeedBack({ companyId: userData?.companyId }));
        return () => {

        }
    }, []);
    // Column configuration
    const columns = [
        {
            title: 'Review From',
            dataIndex: 'conversationId',
            key: 'conversationId',
            width: 150,
            render: (text) => <Tag color="blue">{text?.visitor}</Tag>,
        },
        {
            title: 'Agent',
            dataIndex: 'agentId',
            key: 'agentId',
            render: (_, record) => (
                <Space direction="vertical" size={0}>
                    {/* <div>{record.email}</div> */}
                    <p style={{ margin: 0, fontWeight: 600 }}>Sudo-Name : <span style={{ margin: 0, fontWeight: 400 }}>{_?.sudoName}</span></p>
                    <p style={{ margin: 0, fontWeight: 600 }}>Name : <span style={{ margin: 0, fontWeight: 400 }}>{_?.name}</span></p>
                </Space>
            ),
        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'message',
            ellipsis: true,
        },
        {
            title: 'Rating',
            dataIndex: 'rate',
            key: 'rate',
            width: 200,
            render: (rating) => (
                <Rate
                    disabled
                    defaultValue={rating}
                    style={{ fontSize: 16 }}
                />
            ),
        },
        // {
        //   title: 'Status',
        //   dataIndex: 'status',
        //   key: 'status',
        //   width: 100,
        //   render: (status) => {
        //     let color = '';
        //     switch (status) {
        //       case 'new': color = 'volcano'; break;
        //       case 'pending': color = 'orange'; break;
        //       case 'resolved': color = 'green'; break;
        //       default: color = 'gray';
        //     }
        //     return <Tag color={color}>{status.toUpperCase()}</Tag>;
        //   },
        //   filters: [
        //     { text: 'New', value: 'new' },
        //     { text: 'Pending', value: 'pending' },
        //     { text: 'Resolved', value: 'resolved' },
        //   ],
        //   onFilter: (value, record) => record.status === value,
        // },
    ];

    const handleCloseSidebar = () => {
        setisShow(false);
        setTimeout(() => {
            setSelected([]);
        }, 200);

    }

    const onClickRow = (data) => {
        setisShow(true);
        setSelected(data)
    }

    return (
        <div style={{ padding: 24 }}>
            <Table
                dataSource={feedBackData}
                columns={columns}
                rowKey={record => record._id}
                loading={isLoadingFeedBack}
                onRow={(data, rowIndex) => {
                    return {
                        onClick: (event) => onClickRow(data),
                    };
                }}
                pagination={{ pageSize: 10 }}
                scroll={{ x: 'max-content' }}
                bordered
                title={() => (
                    <div className="feedbackPage__tableTitle">
                        <h2>Customer FeedBack</h2>
                        <span>Total: {feedBackData?.length} entries</span>
                    </div>
                )}
            />
            <Drawer
                title={Selected?.conversationId?.visitor}
                width={520}
                open={isShow}
                onClose={() => handleCloseSidebar()}
            ><>
                    {Selected?.conversationId?.messages?.length > 0 && (
                    <List
                        dataSource={Selected?.conversationId?.messages}
                        renderItem={(message, index) => {
                            const isCurrentUser = message?.senderID === Selected?.agentId?._id;
                            const isSameSender = message?.senderID === Selected?.conversationId?.visitor;
                            return (
                                <List.Item
                                    key={message?.id}
                                    style={{
                                        padding: '4px 0',
                                        width: '100%',
                                        alignSelf: isCurrentUser ? 'flex-end' : 'flex-start'
                                    }}
                                >
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: isCurrentUser ? 'row-reverse' : 'row',
                                        width: '100%',
                                        gap: 8
                                    }}>
                                        {(!isSameSender || isCurrentUser) && (
                                            <Avatar
                                                // src={message.sender.avatar}
                                                icon={<UserOutlined />}
                                                style={{ alignSelf: 'flex-end' }}
                                            />
                                        )}

                                        {isSameSender && !isCurrentUser && (
                                            <Avatar
                                                // src={message.sender.avatar}
                                                icon={<UserOutlined />}
                                                style={{ alignSelf: 'flex-end' }}
                                            />
                                        )}

                                        <div style={{
                                            background: isCurrentUser
                                                ? "lightgray"
                                                : "#eeeeee",
                                            borderRadius: 18,
                                            padding: '12px 16px',
                                            maxWidth: 200,
                                            borderBottomRightRadius: isCurrentUser ? 4 : 18,
                                            borderBottomLeftRadius: isCurrentUser ? 18 : 4,
                                        }}>
                                            <div style={{
                                                color: isCurrentUser ? "#000" : "#000",
                                                whiteSpace: 'pre-wrap',
                                                wordBreak: 'break-word'
                                            }}>
                                                {message?.message}
                                            </div>

                                            <div style={{
                                                textAlign: isCurrentUser ? 'right' : 'left',
                                                marginTop: 4
                                            }}>

                                                {!isSameSender && isCurrentUser && (
                                                    <p style={{ margin: 0, fontSize: 13 }}>{Selected?.agentId?.sudoName}</p>
                                                )}
                                                {isSameSender && !isCurrentUser && (
                                                    <p style={{ margin: 0, fontSize: 13 }}>{Selected?.conversationId?.visitor}</p>
                                                )}
                                                <Typography
                                                    type="secondary"
                                                    style={{
                                                        fontSize: 10,
                                                        color: isCurrentUser
                                                            ? "#000"
                                                            : "#000"
                                                    }}
                                                >
                                                    {new Date(message?.time).toLocaleTimeString([], {
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    })}
                                                </Typography>
                                            </div>

                                        </div>


                                    </div>

                                </List.Item>
                            );
                        }}
                    />
                    )}
                    {Selected?.message && (
                        <div style={{ marginTop: 20 }}>
                            <Typography.Text strong>Feedback Message</Typography.Text>
                            <div style={{
                                background: "#f5f5f5",
                                borderRadius: 8,
                                padding: '12px 16px',
                                marginTop: 8,
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word'
                            }}>
                                {Selected?.message}
                            </div>
                        </div>
                    )}
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 20, flexDirection: "column" }}>
                        <Rate
                            disabled
                            value={Selected?.rate}
                            style={{ fontSize: 25 }}
                        />
                        <p>{Selected?.rate}/5</p>
                    </div>

                </>

            </Drawer>
        </div>
    );
};

export default FeedBack;